import { Phone, MessageSquare, Mail, CalendarDays } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../config/site";

const LINKS = [
  { icon: MessageSquare, label: "Text", sub: CONTACT.phoneDisplay, href: CONTACT.smsHref, testid: "contact-text-button" },
  { icon: Phone, label: "Call", sub: CONTACT.phoneDisplay, href: CONTACT.phoneHref, testid: "contact-call-button" },
  { icon: Mail, label: "Email", sub: "Marlene directly", href: CONTACT.emailHref, testid: "contact-email-button" },
  { icon: CalendarDays, label: "Book a 15-min Talk Story Call", sub: "Via Calendly", href: CONTACT.calendly, testid: "contact-calendly-button", external: true },
];

const ContactStrip = () => (
  <section className="py-24 md:py-32" data-testid="contact-strip-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-teal" data-testid="contact-overline">Talk Story</p>
        <h2 className="font-serif text-3xl sm:text-4xl font-light text-charcoal mt-4 tracking-tight">Questions about Kali&rsquo;u? Just ask.</h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line mt-12" data-testid="contact-buttons">
        {LINKS.map((l, i) => (
          <Reveal key={l.label} delay={i * 0.08} className="bg-ivory">
            <a
              href={l.href}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="flex flex-col gap-6 p-7 md:p-8 h-full hover:bg-sand transition-colors duration-500 group"
              data-testid={l.testid}
            >
              <l.icon size={20} strokeWidth={1.25} className="text-teal" />
              <span>
                <span className="block font-serif text-lg font-light text-charcoal leading-snug">{l.label}</span>
                <span className="block text-xs text-stone2 mt-2">{l.sub}</span>
              </span>
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-xs text-stone2 leading-relaxed italic max-w-3xl" data-testid="contact-showroom-note">
          Showroom visits at 677 Ala Moana Boulevard, Suite 598 are arranged personally through Marlene &mdash; text, call, or book a Talk Story call above.
        </p>
      </Reveal>
    </div>
  </section>
);

export default ContactStrip;

